// MomentBadge — the accessible, non-color/non-motion channel for an emotional moment.
// A moment renders ONLY when its real signal is present (the caller gates on the
// pure predicates in lib/moments.js). Every badge carries a text label + a glyph
// (never color alone) and announces via aria-live so it reaches screen readers even
// when the visual/motion cue is suppressed by prefers-reduced-motion.
import React from "react";

const GLYPHS = {
  supersede: "⟳",
  confidence_up: "▲",
  confidence_down: "▼",
  conflict: "⚠",
  knowledge: "✦",
};

const TONES = {
  neutral: "border-slate-700 text-slate-200",
  positive: "border-emerald-600/50 text-emerald-300",
  caution: "border-amber-600/50 text-amber-300",
  info: "border-sky-600/50 text-sky-300",
};

export default function MomentBadge({ kind, title, detail, tone = "neutral", source, testId }) {
  return (
    <div
      role="status"
      aria-live="polite"
      data-testid={testId || `moment-${kind}`}
      className={`flex items-start gap-2 rounded-md border bg-slate-900/70 px-3 py-2 ${TONES[tone] || TONES.neutral}`}
    >
      <span aria-hidden="true" className="mt-0.5 text-sm">
        {GLYPHS[kind] || "•"}
      </span>
      <div className="min-w-0">
        <p className="text-xs font-medium">{title}</p>
        {detail ? <p className="text-[11px] text-slate-400">{detail}</p> : null}
        {source ? <p className="text-[10px] text-slate-600">{source}</p> : null}
      </div>
    </div>
  );
}
